import type { PublicShopConfig } from '@scayle/storefront-nuxt'

export const getIsSyteEnabled = (currentShop: PublicShopConfig) =>
  Boolean(currentShop.syteScriptTagUrl && currentShop.syteEnabled)
